import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditTLO,
} from "web/components"
import { TLOContextProvider } from "web/contexts"
import { useDeal } from "web/hooks/data"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class DealViewOrEditTLOController extends Controller {
  static values = {
    dealId: Number,
    excludedFieldIds: Array,
    supportsMissingStageFields: { type: Boolean, default: false },
  }

  initialize() {
    global.React = React
  }

  connect() {
    const DealTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider subjectType="deal" data={useDeal(this.dealIdValue)}>
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading inline />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <DealTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditTLO
                    excludedFieldIds={this.excludedFieldIdsValue}
                    supportsMissingStageFields={
                      this.supportsMissingStageFieldsValue
                    }
                  />
                </ErrorBoundary>
              </DealTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }

  disconnect() {
    unmountComponentAtNode(this.element)
  }
}
